$.fn.extend({
    backgroundColour: function(option, elem) {
        var backgrounds = [
            "green",
            "blue",
            "red",
            "yellow",
            "orange",
            "purple"
        ];

        $(elem).removeClass(function(index, className) {
            return(className.match(/(^|\s)background-\S+/g) || []).join(' ');
        });

        for(let i = 0; i < $(elem).length; i++) {
            $(elem)[i].className += ' '+option+'-'+backgrounds[i % backgrounds.length];
        }
    }
});



// WEBPACK FOOTER //
// ./library/js/plugins/background-colour.js